import { Outlet } from "react-router-dom";
import { Sidebar, MobileSidebar } from "./sidebar";
import { Header } from "./header";
import { useInboxes } from "@/hooks/use-inboxes";

export function RootLayout() {
  const { inboxes } = useInboxes("open");
  const inboxOpenCount = inboxes.length;

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar inboxOpenCount={inboxOpenCount} />
      <MobileSidebar inboxOpenCount={inboxOpenCount} />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
